export function formatCount(count: $TSFixMe, round = false) {
  if (count > 1000) {
    if (round) {
      return Math.round(count / 1000) + 'k';
    }
    return Math.round((count / 1000) * 10) / 10 + 'k';
  }
  return count;
}

export function formatThreadLegendId(question: $TSFixMe) {
  return `${question.id}-thread-legend`;
}
/**
 * Converts reply id to a format that can be used in HTML id attribute
 * @param reply
 * @returns
 */
export function formatReplyLegendId(reply: $TSFixMe) {
  return `r-${reply.id.replaceAll('~', '-')}-post-legend`;
}

export function getProfileLinkId(reply: $TSFixMe) {
  return `profile-link-${reply.forumAnswerId}`;
}

// returns the last ID from a ~ separated set of IDs.
// this is useful when you need to get the current level post from a reply.
export function getPostIdFromQuestion(question?: { id: string }) {
  return question?.id?.split('~').pop() || '';
}
